import React, { createContext, useReducer } from "react";
import registerReduce from "./sheetAndRegisterReduce";
import { getService } from "../services/axios/services";

const initialContext = {
  filter: "",
  listOrigins: {
    loading: true,
    result: [],
  },
  listSoap: {
    loading: true,
    result: [],
  },
  listFrequencies: {
    loading: true,
    result: [],
  },
};

const Register = createContext();

const RegisterProvider = ({ children }) => {
  const [state, dispatch] = useReducer(registerReduce, initialContext);

  const loading = (subject, active) => {
    dispatch({ action: "loading", payload: { subject, active } });
  };

  const get = async (path, key) => {
    loading(key, true);
    await getService({ endpoint: path })
      .then((result) => {
        dispatch({ payload: result, key: key, action: "list" });
        loading(key, false);
      })
      .catch((e) => {
        dispatch({
          key: key,
          action: "list",
          payload: { result: "", pagination: {} },
        });
        loading(key, false);
      });
  };

  const _getProgramFrequency = () =>
    get(`varieties/programfrequencies`, "listFrequencies");
  const _getSoap = () => get(`dramaturgies/soapoperaschedules`, "listSoap");
  const _getOrigiins = () => get(`projects/data/origins`, "listOrigins");

  return (
    <Register.Provider
      value={{
        ...state,
        _getSoap,
        _getProgramFrequency,
        _getOrigiins,
      }}
    >
      {children}
    </Register.Provider>
  );
};

export { Register as default, RegisterProvider };
